import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

import { CARD_SHADOW_FILTER } from '../header.constants';
import matchesArrowUrl from './matches-arrow.svg';

// The arrow SVG's rounded right edge is drawn to meet a card with 6px corners. The new look's larger card radius
// would curve away under that edge and leave a notch, so the card's left corners keep this radius in both looks.
const ARROW_JOIN_RADIUS = 6;

const useStyles = makeStyles((theme) => ({
  card: {
    position: 'relative',
    boxSizing: 'border-box',
    height: 48,
    minWidth: 48,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: theme.spacing(2, 4),
    borderRadius: theme.sizes.roundCorners,
    fontSize: 14,
    lineHeight: '20px',
    color: theme.colorPalette.green_90,
    whiteSpace: 'nowrap',
    filter: CARD_SHADOW_FILTER
  },
  empty: {
    border: `2px solid ${theme.colorPalette.white}`,
    '& $primaryText': {
      fontStyle: 'italic'
    }
  },
  linked: {
    backgroundColor: theme.colorPalette.beige_25
  },
  found: {
    marginLeft: 17,
    border: 0,
    font: 'inherit',
    textAlign: 'left',
    color: theme.colorPalette.white,
    // The callout color: orange in the classic look, green in the new one.
    backgroundColor: theme.colors.notice_background,
    cursor: 'pointer',
    borderTopLeftRadius: ARROW_JOIN_RADIUS,
    borderBottomLeftRadius: ARROW_JOIN_RADIUS,
    // The arrow pointing at the applicant's name; the card's own corners are hidden under it.
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: -17,
      width: 28,
      height: 48,
      background: `url("${matchesArrowUrl}") no-repeat right center / contain`
    },
    '& $seeAllMatches': {
      color: theme.colorPalette.white
    }
  },
  primaryText: {
    position: 'relative',
    color: 'inherit',
    textDecoration: 'none',
    fontSize: 14,
    lineHeight: '20px'
  },
  seeAllMatches: {
    position: 'relative',
    padding: 0,
    border: 0,
    background: 'none',
    font: 'inherit',
    fontSize: 10,
    lineHeight: '12px',
    color: theme.colorPalette.orange_50,
    ...reskinStyles(theme, { color: theme.colors.action_text }),
    cursor: 'pointer'
  }
}));

export default useStyles;
